module.exports = __webpack_public_path__ + "img/thumbnail_BorneanPygmyElephant_j_albino.ba523628.png";